// extracted by mini-css-extract-plugin
module.exports = {"sortOptions":"Filters-module__sortOptions___3vX2g","sortHeading":"Filters-module__sortHeading___kuPmH","title":"Filters-module__title___ZvzmZ"};